module.exports = "https://activity.hdslb.com/blackboard/activity38602/static/img/entr-intro_6e50aba.png";